import React, { useRef, useEffect, useCallback } from 'react';
import { useMedia } from '../../../hooks';
import { numberToShow } from '../../../common/utils';
import { MediaEvents } from '../../../common/media';

type TimelineProps = {
  target: string;
};

const Timeline = ({ target }: TimelineProps) => {
  const lineRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);
  const media = useMedia(target);

  const timeChangeHandler = useCallback(
    (event: any) => {
      const totalTime = media?.getDuration() || 0;
      const wrapper_width = Number(event.target.offsetWidth);
      const clickCoordX = event.nativeEvent.layerX;

      const coordByPr = clickCoordX / wrapper_width; // 0 - 1 range

      let time = totalTime * coordByPr;

      if (time > totalTime) {
        time = totalTime;
      }

      media?.setCurrentTime(time);
    },
    [media]
  );

  useEffect(() => {
    if (!media) return;

    type TData = { currentTime: number; duration: number };

    const handleTimeupdate = ({ currentTime, duration }: TData) => {
      if (textRef.current && lineRef.current) {
        const totalMin = Math.floor(duration / 60) || 0;
        const totalSec = Math.floor(duration - totalMin * 60) || 0;
        const currentMin = Math.floor(currentTime / 60) || 0;
        const currentSec = Math.floor(currentTime - currentMin * 60) || 0;

        const text = `${numberToShow(currentMin)}:${numberToShow(currentSec)} | ${numberToShow(
          totalMin
        )}:${numberToShow(totalSec)}`;

        textRef.current.innerText = text;

        const wrapper_width = Number(lineRef.current.parentElement?.offsetWidth);

        const width = (wrapper_width * currentTime) / duration;

        lineRef.current.style.width = `${width}px`;
      }
    };

    media.on(MediaEvents.Timeupdate, handleTimeupdate);

    return () => {
      media.off(MediaEvents.Timeupdate, handleTimeupdate);
    };
  }, [media]);

  return (
    <>
      <div className="player-footer-seekbar " onClick={timeChangeHandler}>
        <div className="player-footer-seekbar-bg">
          <div className="player-footer-seekbar-fill" ref={lineRef}></div>
        </div>
      </div>
      <div className="player-footer-timelabelWrap">
        <span className="player-footer-duration" ref={textRef}>
          00:00 | 00:00
        </span>
      </div>
    </>
  );
};

export default Timeline;
